import React, { useState } from "react";
import "./App.css";
import Expenses from "./commponents/Expenses/Expenses";

const DUMMY_DATA = [
  {
    id: "e1",
    title: "Toilet Paper",
    amount: 94.12,
    date: new Date(2021, 7, 14),
  },
  { id: "e2", title: "New TV", amount: 799.49, date: new Date(2022, 2, 12) },
  {
    id: "e3",
    title: "Car Insurance",
    amount: 294.67,
    date: new Date(2022, 2, 28),
  },
  {
    id: "e4",
    title: "New Desk (Wooden)",
    amount: 450,
    date: new Date(2022, 5, 12),
  },
];
function App() {
  const [data, setData] = useState(DUMMY_DATA);

  const getExpensesFromFinal = (getData) => {
    setData((prevData) => [getData, ...prevData]);
  };
  return (
    <div className="App">
      <Expenses getData={getExpensesFromFinal} items={data} />
    </div>
  );
}

export default App;
